import sendOnChange from "./sendOnChange";
import reg_keyboard from "./reg_keyboard";

let find_city = () => {
    const hiddenCityes = document.q;
    const parentDiv = document.querySelector(".live-search");
    const search_clear = parentDiv.querySelector(".modal-address__close");
    const searchInput = parentDiv.querySelector("#live-search");
    const search_list = parentDiv.querySelector("#city-get");
    const search_help = parentDiv.querySelector(".modal-address__info");
    searchInput.addEventListener("input", function (event) {
        let input = event.target;
        let query = reg_keyboard(event.target.value);
        let list = parentDiv.querySelectorAll(".city-item");
        let data = parentDiv.querySelectorAll(".city-item a");
        let clear_js = (ev1) => {
            ev1.closest(".city-item").style.display = "block";
            ev1.closest(".city-item").setAttribute("data-selects", "");
            ev1.parentNode.setAttribute("data-select", "");
            if (ev1.parentNode.getAttribute("data-priority"))
                ev1.parentNode.style.display = "block";
            else ev1.parentNode.style.display = "none";
        };
        let add_js = (ev1) => {
            ev1.parentNode.style.display = "none";
            ev1.parentNode.removeAttribute("data-select");
            if (
                !ev1
                    .closest(".city-item")
                    .contains(
                        ev1
                            .closest(".city-item")
                            .querySelector("[data-select]")
                    )
            ) {
                ev1.closest(".city-item").style.display = "none";
                ev1.closest(".city-item").removeAttribute("data-selects");
            }
        };
        if (input.value.length > 1) {
            search_clear.style.display = "flex";
            for (let i = 0, len = data.length; i < len; i++) {
                data[i].innerHTML
                    .toLowerCase()
                    .includes(query.toLowerCase())
                    ? clear_js(data[i])
                    : add_js(data[i]);
            }

            for (let i = 0, lens = list.length; i < lens; i++) {
                if (
                    list[i].parentNode.querySelectorAll("[data-selects]")
                        .length == 0
                ) {
                    search_list.style.display = "none";
                    search_help.style.display = "block";
                } else {
                    search_list.style.display = "block";
                    search_help.style.display = "none";
                }
            }
        } else {
            search_clear.style.display = "none";
            for (let i = 0, len = data.length; i < len; i++) {
                data[i].parentNode.removeAttribute("style");
                data[i].parentNode.removeAttribute("data-select");
                data[i]
                    .closest(".city-item")
                    .removeAttribute("data-selects");
                data[i].closest(".city-item").removeAttribute("style");

                if (
                    !(data[i].parentNode.getAttribute("data-priority") * 1)
                ) {
                    data[i].parentNode.style.display = "none";
                }
                search_list.style.display = "block";
                search_help.style.display = "none";
            }
        }
    });
    search_clear.onclick = function () {
        searchInput.value = "";
        searchInput.focus();
        sendOnChange(searchInput);
    };
};

export default find_city;
